// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-medium-badge-dc7c75fb"};